import gql from "graphql-tag";

export default gql`
  query Users($offset: Int, $limit: Int, $username: String, $customerId: ID) {
    users(offset: $offset, limit: $limit, username: $username, customerId: $customerId) {
      items {
        id
        username
        name
        email
        telephone
        roles {
          id
          name
        }
      }
      total
    }
  }
`;
